<template lang="pug">
v-row(class="justify-space-btween") 
  v-col(:cols="searchIsDoneAtLeastOnce ? 3 : 6" class="mb-n8")
    v-text-field(
      label="search"
      outlined
      dense
      v-on:keydown.enter.prevent="handleInputEnter" 
      v-model="searchString"
      placeholder="Search"
    )
      template(#append)
            v-icon(@click="executeSearch") mdi-magnify
  v-col(v-if="searchIsDoneAtLeastOnce" cols="3" class="mb-n8")
    v-menu(
      ref="daterange"
      v-model="dateRangeMenu"
      :close-on-content-click="false"
      :return-value.sync="dateRange"
      transition="scale-transition"
      offset-y
      min-width="auto"
    )
      template(v-slot:activator="{ on, attrs }")
        v-text-field(
          outlined
          dense
          clearable
          v-model="dateRangeComputed"
          label="Date Range"
          readonly
          v-bind="attrs"
          v-on="on"
        )
      v-date-picker(
        v-model="dateRange"
        no-title
        range
        scrollable
      )
        v-spacer
        v-btn(
          text
          color="primary"
          @click="dateRangeMenu = false"
        ) Cancel
        v-btn(
          text
          color="primary"
          @click="$refs.daterange.save(dateRange)"
        ) OK
  v-col(v-if="searchIsDoneAtLeastOnce" cols="3" class="mb-n8")
    v-select(
      label="Results per Page"
      v-model="resultsPerPage"
      :items="perPageOptions"
      dense
      outlined
    )
  v-col(v-if="searchIsDoneAtLeastOnce" cols="3" class="mb-n8")
    v-select(
      label="Order"
      v-model="orderBy"
      :items="orderByOptions"
      dense
      outlined
    )
  v-col(v-for="(filter, i) in filterKeys" :key="i" cols="3" class="mb-n8")
    DropdownFacet(v-if="searchIsDoneAtLeastOnce" v-bind:facet="facets[filter]" :field="filter")
  v-col(v-if="searchIsDoneAtLeastOnce" cols="3")
    ClearFilters

</template>

<script>
import moment from "moment";
import { mapState } from "vuex";
import DropdownFacet from "@/components/search/SearchDropdownFacet.vue";
import ClearFilters from "@/components/search/SearchClearFilters.vue";
export default {
  data() {
    return {
      dateRange: [],
      filterKeys: [
        "type",
        "tactic",
        "sectors",
        "issues",
        "campaigns",
        "location",
      ],
      dateRangeMenu: false,
      pages: 10,
      perPageOptions: [
        { text: "10", value: 10, disabled: false },
        { text: "20", value: 20, disabled: false },
        { text: "50", value: 50, disabled: false },
        { text: "100", value: 100, disabled: false },
      ],
      orderByOptions: [
        { text: "Relevance", value: "search.score() desc", disabled: false },
        {
          text: "Last Modified",
          value: "lastModifiedDate desc",
          disabled: false,
        },
      ],
    };
  },
  components: {
    DropdownFacet,
    ClearFilters,
  },
  methods: {
    executeSearch() {
      this.$store.dispatch("search/executeSearch");
    },
    selected(field, data) {
      const payload = {
        facet: field,
        selected: data,
      };
      this.$store.dispatch("search/setFilter", payload);
    },
    handleInputEnter(e) {
      this.$store.dispatch("search/executeSearch");
    },
  },
  computed: {
    ...mapState("search", [
      "resultsCount",
      "facets",
      "filters",
      "searchIsDoneAtLeastOnce",
    ]),
    dateRangeComputed: {
      set(value) {
        this.dateRange = value;
      },
      get() {
        const dateRange = this.dateRange;
        if (dateRange && dateRange.length === 2) {
          return `${moment(dateRange[0]).format("DD MMM YYYY")} - ${moment(
            dateRange[1]
          ).format("DD MMM YYYY")}`;
        }
        return null;
      },
    },
    searchString: {
      get() {
        return this.$store.state["search"].searchString;
      },
      set(value) {
        this.$store.dispatch("search/setSearchString", value);
      },
    },
    resultsPerPage: {
      get() {
        return this.$store.state["search"].resultsPerPage;
      },
      set(value) {
        this.$store.dispatch("search/setResultsPerPage", value);
      },
    },
    orderBy: {
      get() {
        return this.$store.state["search"].orderBy;
      },
      set(value) {
        this.$store.dispatch("search/setOrderBy", value);
      },
    },
  },
  watch: {
    "$route.query.keyword": {
      deep: true,
      immediate: true,
      handler(v) {
        if (v) {
          this.$store.dispatch("search/setSearchString", v);
          this.executeSearch()
        }
      },
    },
    filters() {
      if (!this.filters[this.field]) {
        this.dateRange = [];
      }
    },
    dateRange: {
      deep: true,
      handler(v) {
        if (!v || v.length === 2) {
          this.selected("dateRange", v);
        }
      },
    },
  },
};
</script>
